import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useLoginInfoQuery } from '../../api/portalGateway/loginInfo';
import { useStore } from '../../store';
import { getTenantNameBySubdomain } from '../../utils/getTenantNameBySubdomain';

export type TenantPreLoaderChildren = Pick<
  ReturnType<typeof useLoginInfoQuery>,
  'data' | 'isError'
>;

export function TenantPreLoader({
  children,
}: {
  children: (tenantLoginInfoData: TenantPreLoaderChildren) => JSX.Element;
}) {
  const [initSession, setApiId, setTenantName] = useStore(
    useShallow((state) => [
      state.initSession,
      state.setApiId,
      state.setTenantName,
    ])
  );

  // set current api id for portal-gateway client
  useEffect(() => {
    setTenantName(getTenantNameBySubdomain());
  }, [setTenantName]);

  const { isError, data } = useLoginInfoQuery();

  useEffect(() => {
    if (data?.apiId) {
      setApiId(data.apiId);
      initSession(data.apiId);
    }
  }, [data?.apiId, initSession, setApiId]);

  return children({
    data,
    isError,
  });
}
